export default "__VITE_ASSET__LvDSh417__"